module.exports = __webpack_public_path__ + "static/LRCC-campaign-mobile-43f57e61c57d34a26539d3e3da573fa7.jpg";